import { Component, OnInit, ViewChild } from '@angular/core';
import { HttpService } from '../../services/http.service';
import { HelperService } from '../../services/helper.service';
import { DropDownList } from "../../models/dropdownlist.model";
import { PrincipalCheckedModel } from "../../models/Principal/principal-checked.model";
@Component({
    selector: '',
    templateUrl: 'user-role-on-principal.html',
})
export class UserRoleOnPrincipalComponent implements OnInit {

    userSelected: number = 0;
    userNameSelected: string = "";
    userType: string = "";
    fields: Object = { text: 'label', value: 'value' };
    userTypeDDL: Array<any> = [
        { label: "Tender ZPV", value: "ZPV" },
        { label: "Principal User", value: "PRN" }
    ];
    isCheckAll: boolean = false;

    constructor(private http: HttpService, private helper: HelperService) {

    }
    userDDL: Array<DropDownList> = [];
    lstAllPrincipal: Array<PrincipalCheckedModel> = [];
    ngOnInit() {

    }
    getUserDDL(type:string) {
        this.http.get('api/PrincipalUser/GetUserByTypeDDL?userType=' + type, res => {
            this.userDDL = res;
        }, null);
    }
    loadPrincipalChecked() {
        this.http.get('api/PrincipalUser/GetPrincipalCheckedByUser?userName=' + this.userNameSelected, res => {
            this.lstAllPrincipal = res;
        }, null);
    }
    onChangeUser(e) {
        this.userSelected = e.value;
        this.userNameSelected = e.itemData.label;
        this.loadPrincipalChecked();
    }
    onChangeUserType(e) {
        this.userType = e.value;
        this.getUserDDL(this.userType)
    }
    onCheckPrincipal(item: PrincipalCheckedModel) {
        item.Checked = !item.Checked;
    }
    saveStaffBasePrincipal() {
        var lstChecked = this.lstAllPrincipal.filter(x => x.Checked == true);
        let dataSave = {
            UserID: this.userSelected,
            UserName: this.userNameSelected,
            UserType: this.userType,
            lstPrincipal: lstChecked
        };

        this.http.save('api/PrincipalUser/SaveUserRoleOnPRN', dataSave, res => {
            this.loadPrincipalChecked();
        }, null);
    }
    onCheckAll(e) {
        this.isCheckAll = !this.isCheckAll;
        this.lstAllPrincipal.map(x => x.Checked = this.isCheckAll);
    }
}
